import React from 'react';
import { Badge } from '../ui/badge';
import {
  Recycle,
  Beaker,
  Leaf,
  CheckCircle2,
  Factory,
  ArrowRight
} from 'lucide-react';

const STEPS = [
  { step: '01', title: 'Waste Collection', description: 'Source urban, agri, and textile waste from local streams', icon: Factory },
  { step: '02', title: 'Processing', description: 'Sort, clean, and prepare feedstock for transformation', icon: Recycle },
  { step: '03', title: 'Biofabrication', description: 'Apply biology-driven processes to create new materials', icon: Beaker },
  { step: '04', title: 'Product Creation', description: 'Manufacture acoustic panels, biosorbents, and more', icon: CheckCircle2 },
  { step: '05', title: 'Biodegradation', description: 'End-of-life products return safely to the ecosystem', icon: Leaf },
];

export const CircularProcess = () => (
  <section className="py-20 px-6 bg-[#FDFBF7]">
    <div className="container mx-auto max-w-6xl">
      <div className="text-center mb-16">
        <Badge className="bg-[#E8E3DA] text-[#4A5D4E] border-none mb-4">
          <Recycle className="w-3 h-3 mr-1" />
          Our Circular Process
        </Badge>
        <h2 className="text-4xl font-bold text-[#2C3E2F] mb-4">
          From Waste to Wonder
        </h2>
        <p className="text-xl text-[#D4A574] font-semibold italic mb-3 max-w-3xl mx-auto">
          What if Biology is used to grow high performance materials, instead of manufacturing them?
        </p>
        <p className="text-lg text-[#5A6B5E] max-w-3xl mx-auto">
          A regenerative cycle that transforms urban waste into valuable materials, 
          then back to nature.
        </p>
      </div>

      <div className="relative">
        <div className="grid md:grid-cols-5 gap-6">
          {STEPS.map((item, index) => (
            <div key={item.step} className="relative">
              <div className="bg-white rounded-xl p-6 border border-[#DDD5C7] hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-[#A8C9A5]/20 rounded-full flex items-center justify-center mb-4">
                  <item.icon className="w-6 h-6 text-[#4A5D4E]" />
                </div>
                <div className="text-sm font-bold text-[#D4A574] mb-2">{item.step}</div>
                <h3 className="font-bold text-[#2C3E2F] mb-2">{item.title}</h3>
                <p className="text-sm text-[#5A6B5E]">{item.description}</p>
              </div>
              {index < 4 && (
                <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                  <ArrowRight className="w-6 h-6 text-[#A8C9A5]" />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="hidden md:flex justify-center mt-8">
          <div className="flex items-center gap-2 text-[#A8C9A5]">
            <ArrowRight className="w-6 h-6 rotate-180" />
            <span className="text-sm font-medium text-[#4A5D4E]">Continuous Cycle</span>
            <ArrowRight className="w-6 h-6 rotate-180" />
          </div>
        </div>
      </div>
    </div>
  </section>
);
